<template>
  <FormContainer >
    <template #title>Prestataire</template>
    <template #content>
            <div class="form__bloc">
        <WrapperAutocomplete
          id="field_162"
          key-id="siret.valeur"
          key-label="denomination"
          v-model="etablissementPrestataire"
          label="Rechercher prestataire"
          hint="Siren ou Siret du prestataire"
          class="col-24 col-md-20 col-sm-36"
          :search-min-length="9"
          :placeholder="PLACE_HOLDER_SIREN"
          :readonly
          strict
          :alertLabel="meta.prestation?.etablissement?.$messageErreurDirty!"
          :required="meta.prestation?.etablissement?.$status === PropertyStatus.Required"
          :search="searchPrestataire"
          :search-formater="sirenSiretSearchFormater"
        >
          <template v-slot="{ denomination, siret, adresse, estEtablissementSiege, etatAdministratif }">
            <div>
              <div>
                <BasicText weight="bold">{{ denomination }} - {{ siret.valeur }}</BasicText>
                <BasicText
                  v-if="estEtablissementSiege === true"
                  color="primary-600"
                >
                  - SIEGE
                </BasicText>
                <BasicText
                  v-if="etatAdministratif === 'F'"
                  color="red"
                >
                  (Inactif)
                </BasicText>
              </div>
              <div style="margin-top: -3px">
                <BasicText size="body-m">
                  {{ adresse?.voie }} {{ adresse?.codePostal }} {{ adresse?.commune }}
                </BasicText>
              </div>
            </div>
          </template>
        </WrapperAutocomplete>
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_167"
          :model-value="model?.prestation?.etablissement?.siret?.valeur"
          label="SIRET"
          class="col-8 col-md-12 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_166"
          :model-value="model?.prestation?.etablissement?.uai"
          label="N° UAI"
          :alertLabel="meta.prestation?.etablissement?.uai?.$messageErreurDirty!"
          class="col-4 col-md-8 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_168"
          :model-value="model?.prestation?.etablissement?.nda"
          label="N° d'activité"
          :alertLabel="meta.prestation?.etablissement?.nda?.$messageErreurDirty!"
          class="col-4 col-md-8 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_164"
          :model-value="qualiopiLibelle"
          label="Qualiopi"
          :alertLabel="meta.prestation?.etablissement?.certificationQualiopi?.$messageErreurDirty!"
          class="col-20 col-md-12 col-sm-36"
          disabled
          help="La certification Qualiopi est obligatoire pour tous les prestataires d'actions concourant au développement des compétences, et ce depuis le 1er janvier 2022."
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_170"
          :model-value="model?.prestation?.etablissement?.adresse?.voie"
          :label="LABEL_NUMERO_VOIE"
          class="col-12 col-md-16 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_171"
          :model-value="model?.prestation?.etablissement?.adresse?.complement"
          label="Complément d'adresse"
          class="col-12 col-md-16 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_172"
          :model-value="model?.prestation?.etablissement?.adresse?.codePostal"
          label="Code postal"
          class="col-4 col-md-6 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_173"
          :model-value="model?.prestation?.etablissement?.adresse?.commune"
          label="Commune"
          class="col-8 col-md-10 col-sm-36"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import type { EtablissementPrestataireDTO } from '@/features/api/extranet/dto/shared'
import { PropertyStatus } from '@/features/domaine/property-status'
import { CertificationQualiopiLibelle } from '@/features/domaine/types/opco'
import { FormContainer, LABEL_NUMERO_VOIE, PLACE_HOLDER_SIREN } from '@/features/interface/demande/shared'
import { sirenSiretSearchFormater } from '@/features/interface/shared/tools'
import { storeToRefs } from 'pinia'
import { computed, inject } from 'vue'
import { OUTIL_FPE_ACTIONS } from '../../../../useDemandeOutilFPEActions.ts'
import { useDemandeOutilFPEStore } from '../../../../useDemandeOutilFPEStore.ts'
  const store = useDemandeOutilFPEStore()

  const { model, readonly, meta } = storeToRefs(store)
  const { setupFieldWithKey } = store

    const { searchPrestataire } = inject(OUTIL_FPE_ACTIONS)!

  const etablissementPrestataire = setupFieldWithKey<EtablissementPrestataireDTO>('prestation.etablissement')

  const qualiopiLibelle = computed(() => {
    return (
      model.value?.prestation?.etablissement?.certificationQualiopi
        ?.map((item) => CertificationQualiopiLibelle[item])
        ?.join(', ') ?? ''
    )
  })

</script>
